import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * COMPLIANCE: The LeadConnector chat widget must NEVER appear on the same page
 * as any form that collects a phone number. Chat is enabled on every route
 * EXCEPT the ones in CHAT_BLOCKED_ROUTES below (which host phone-collection
 * forms). If you add a new page that collects a phone number, add its pathname
 * here.
 */
const CHAT_BLOCKED_ROUTES = ["/request-offer", "/get-offer"];
const SCRIPT_ID = "leadconnector-chat-loader";
const WIDGET_ID = "6ab45e9bfad6c0284b2ef233";

function removeChatWidget() {
  const existing = document.getElementById(SCRIPT_ID);
  if (existing) existing.remove();
  // The widget mounts a custom element, plus iframes and injected styles.
  document
    .querySelectorAll(
      "chat-widget, [class*='leadconnector'], iframe[src*='leadconnectorhq'], script[src*='leadconnectorhq'], link[href*='leadconnectorhq']"
    )
    .forEach((el) => el.remove());
}

function injectChatWidget() {
  if (document.getElementById(SCRIPT_ID)) return;
  const s = document.createElement("script");
  s.id = SCRIPT_ID;
  s.src = "https://widgets.leadconnectorhq.com/loader.js";
  s.setAttribute(
    "data-resources-url",
    "https://widgets.leadconnectorhq.com/chat-widget/loader.js"
  );
  s.setAttribute("data-widget-id", WIDGET_ID);
  s.setAttribute("data-source", "WEB_USER");
  s.async = true;
  document.body.appendChild(s);
}

export default function ChatWidget() {
  const { pathname } = useLocation();

  useEffect(() => {
    const blocked = CHAT_BLOCKED_ROUTES.includes(pathname);
    if (blocked) {
      removeChatWidget();
      // Safety net: some SPA transitions race the widget's late-mount — re-strip
      // shortly after route change to guarantee it never briefly appears.
      const t1 = setTimeout(removeChatWidget, 500);
      const t2 = setTimeout(removeChatWidget, 1500);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
    injectChatWidget();
    return undefined;
  }, [pathname]);

  return null;
}
